<div class="mep-dialog-header-icon">
	<mat-icon>code</mat-icon>
</div>
<div class="mep-dialog-title">{{ _lang("attributes.add_source_code_storage") }}</div>

<div class="mep-dialog-content" mat-dialog-content>
	<form class="col pt-2" [formGroup]="sourceCodeForm">
		<mat-radio-group formControlName="sourceCodeStorageLocation" (change)="onRadioButtonChanged()">
			<div class="row m-1 mt-2">
				<mat-radio-button
					id="add_source_code_dialog-NO_SOURCE_CODE"
					class="mt-2 mb-4"
					[value]="sourceCodeStorageLocation.NO_SOURCE_CODE"
				>
					{{ _lang("attributes.no_source_code") }}
				</mat-radio-button>
			</div>

			<div class="row m-1 mt-2">
				<mat-radio-button
					id="add_source_code_dialog-CLIENT_RESPONSIBILITY"
					class="mt-2 mb-4"
					[value]="sourceCodeStorageLocation.CLIENT_RESPONSIBILITY"
				>
					{{ _lang("attributes.client_responsibility") }}
				</mat-radio-button>
			</div>

			<div class="row m-1 mt-2">
				<mat-radio-button
					id="add_source_code_dialog-BUSINESSUNIT_RESPONSIBILITY"
					class="mt-2 mb-4"
					[value]="sourceCodeStorageLocation.BUSINESSUNIT_RESPONSIBILITY"
				>
					{{ _lang("attributes.businessunit_responsibility", {responsibleBusinessUnit: responsibleBusinessUnit}) }}
				</mat-radio-button>
			</div>
		</mat-radio-group>

		<div formGroupName="businessUnitResponsibilityFields">
			<div class="row m-2 mt-2">
				<mat-form-field class="form-field-size" id="add_source_code_dialog-stackIntegratedStorage">
					<mat-label> {{ _lang("attributes.stack_integrated_storage") }} </mat-label>
					<textarea matInput formControlName="stackIntegratedStorage"></textarea>
				</mat-form-field>
			</div>

			<div class="row m-2 mt-2">
				<mat-form-field class="form-field-size" id="add_source_code_dialog-msgHub">
					<mat-label>msg.HUB or Github Enterprise by msg</mat-label>
					<textarea matInput placeholder="Link oder andere" formControlName="msgHub"></textarea>
				</mat-form-field>
			</div>

			<div class="anotherCloudSource mt-4">
				<mat-panel-title class="title"> {{ _lang("attributes.other_cloud_source_code") }} </mat-panel-title>

				<div class="row m-2">
					<mat-form-field class="form-field-size me-2" id="add_source_code_dialog-cloudSourceStorage">
						<mat-label>{{ _lang("attributes.other_cloud_source_code") }}</mat-label>
						<textarea #cloudSourceStorage matInput formControlName="cloudSourceStorage"></textarea>
						@if (cloudSourceStorage.value && !reasonForOtherCloudSource.value) {
							<mat-hint align="start">{{ _lang("attributes.usage_of_other_repository") }} </mat-hint>
						}
					</mat-form-field>
				</div>

				<div class="row m-2">
					<mat-form-field class="form-field-size" id="add_source_code_dialog-reasonForOtherCloudSource">
						<mat-label> {{ _lang("attributes.reason_for_other_cloudsource") }}</mat-label>
						<input #reasonForOtherCloudSource matInput formControlName="reasonForOtherCloudSource" />
					</mat-form-field>
				</div>
			</div>
		</div>
	</form>
</div>
@if (sourceCodeForm.invalid) {
	<div class="mep-hint">
		{{ _lang("attributes.at_least_one_option") }}
	</div>
}
<div class="mep-hint">
	{{ _lang("attributes.hint_save_repository") }}
</div>
<div class="mep-dialog-actions">
	<button class="mep-btn-dialog-secondary" appEscapeHotkey (click)="closeDialog()">
		{{ "mep.components.general.cancel" | translate }}
	</button>
	<button
		class="mep-btn-dialog-primary"
		appSaveHotkey
		[disabled]="
			(cloudSourceStorage?.value && !reasonForOtherCloudSource?.value) ||
			(reasonForOtherCloudSource.value && !cloudSourceStorage?.value) ||
			sourceCodeForm.invalid
		"
		[mat-dialog-close]="getResult()"
	>
		{{ "mep.components.general.add" | translate }}
	</button>
</div>
